import React, { useEffect, useState } from 'react';
import {
  Building,
  Building2,
  BookOpen,
  GraduationCap,
  Landmark,
  Library,
  Map as MapIcon,
  Scale,
  School,
  Shield,
  Stethoscope,
  Target
} from 'lucide-react';
import { TIPOS_ENTIDAD, tipoDeEntidad } from '../services/entidadLogos';
import './logo-entidad.scss';

// Logo de una entidad pública, resuelto en tres capas:
//
//   1. El logo propio que el administrador subió (o la URL que pegó).
//   2. Un icono según el TIPO de entidad, deducido de su nombre.
//   3. Las iniciales de la entidad.
//
// La capa 2 existe porque `trabajos_estado` trae 488 entidades distintas y 113
// aparecen una sola vez: con un icono por tipo se cubre ~73 % de las filas sin
// subir un solo archivo. Ver `src/services/entidadLogos.js`.
const ICONOS = {
  justicia: Scale,
  salud: Stethoscope,
  defensa: Shield,
  ugel: School,
  universidad: GraduationCap,
  municipalidad: Landmark,
  regional: MapIcon,
  ministerio: Building2,
  programa: Target,
  educacion: BookOpen,
  organismo: Library,
  otra: Building
};

// Color de respaldo cuando el tipo no manda uno: se elige por el nombre y no
// por la posición en la lista, para que una misma institución conserve su
// color al filtrar o al cambiar de página.
const paletaPorNombre = (texto) => {
  const base = String(texto || '');
  let suma = 0;
  for (let i = 0; i < base.length; i++) suma = (suma + base.charCodeAt(i)) % 6;
  return suma;
};

export const inicialesEntidad = (entidad) => {
  const palabras = String(entidad || '')
    .split(/[\s.,/-]+/)
    .filter((p) => p.length > 3);
  const iniciales = palabras.slice(0, 2).map((p) => p[0]).join('');
  return (iniciales || String(entidad || '?').slice(0, 2)).toUpperCase();
};

const LogoEntidad = ({ nombre, url, tamano = 40, className = '' }) => {
  // Una URL que no carga (la entidad movió el archivo, el bucket cambió) no
  // puede dejar un hueco: se vuelve a las capas de abajo.
  const [roto, setRoto] = useState(false);

  useEffect(() => { setRoto(false); }, [url]);

  const tipo = tipoDeEntidad(nombre);
  const Icono = ICONOS[tipo] || Building;
  const paleta = TIPOS_ENTIDAD[tipo]?.paleta ?? paletaPorNombre(nombre);
  const estilo = { width: tamano, height: tamano, borderRadius: Math.round(tamano * 0.275) };

  if (url && !roto) {
    return (
      <span className={`le-logo le-logo--img ${className}`} style={estilo}>
        <img
          src={url}
          alt=""
          loading="lazy"
          onError={() => setRoto(true)}
        />
      </span>
    );
  }

  if (tipo !== 'otra') {
    return (
      <span
        className={`le-logo le-pal-${paleta} ${className}`}
        style={estilo}
        title={TIPOS_ENTIDAD[tipo]?.label}
        aria-hidden="true"
      >
        <Icono size={Math.round(tamano * 0.45)} strokeWidth={2.1} />
      </span>
    );
  }

  return (
    <span
      className={`le-logo le-logo--txt le-pal-${paleta} ${className}`}
      style={{ ...estilo, fontSize: Math.round(tamano * 0.325) }}
      aria-hidden="true"
    >
      {inicialesEntidad(nombre)}
    </span>
  );
};

export default LogoEntidad;
